import axios from 'axios';
import { Loading,Message } from 'element-ui';
import Router from '../router/index.js'
import { log, getUserId ,utils} from '@/common/common.js'


var baseUrl_dev  = 'https://api.dev.ysintelligent.com/' // 'https://api.dev.ysintelligent.com/'  //dev
var baseUrl_test ='https://api.test.ysintelligent.com/'  //test
var baseUrl      ='https://api.ysintelligent.com/'


var imgPrev_dev='https://static.dev.ysintelligent.com/'
var imgPrev_test='https://static.test.ysintelligent.com/'
var imgPrev='https://static.ysintelligent.com/'

var environmental=utils.getCurrentApi()
var resultApi={}

if(environmental=='dev'){
    resultApi={
    	baseUrl:baseUrl_dev,
    	imgPrev:imgPrev_dev
    }
}
if(environmental=='test'){
    resultApi={
    	baseUrl:baseUrl_test,
    	imgPrev:imgPrev_test
    }
}
if(environmental=='prod'){
    resultApi={
    	baseUrl:baseUrl,
    	imgPrev:imgPrev
    }
}

export const importApi = resultApi.baseUrl;

 // var resultApi={
 //    baseUrl:baseUrl,
 //    imgPrev:imgPrev
 //  }
// var resultApi={
//   baseUrl:'https://api.dev.ysintelligent.com/digital_warehouse_php'
// }
// export const api=resultApi
// var instance = axios.create({
// 	baseURL: api.baseUrl,
// 	timeout: 200000,
// });


// export const api='/apis'//修改这里
// export const api=resultApi.baseUrl//线上时用这个
var instance = axios.create({
	baseURL: resultApi.baseUrl,
	timeout: 0,
  // headers:{
  //   thisistest:"footbar"
  // }
});





export function ajaxImport(url, data) {
	let args=data
	//promise
	let p = new Promise(function(resolve, reject) {
		instance({
			method: 'post',
			url: url,
      // type:'json',
			data:args
		}).then(function(response) {
			resolve(response.data)//resolve
		}).catch(function(response) {
			Message({
				message: "请求异常",
				type: 'error',
				duration: 1500
			});
			reject(response.data)//reject
		})
	})
	return p

}



// WEBPACK FOOTER //
// ./src/common/request_import.js